import React from 'react'
import Title from '../components/Title'
import SkillsSection from '../components/SkillsSection'

const Skills = () => {
    return (
        <div className="SkillsPage">
             <Title title={'Skills'} span={'Skills'} />
             <div className="skillsContainer">           
                <SkillsSection skill={'Node Js'} progress={'80%'} width={'80%'} />
                <SkillsSection skill={'Express Js'} progress={'85%'} width={'85%'} />
                <SkillsSection skill={'Databases'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'MongoDB'} progress={'75%'} width={'75%'} />
                <SkillsSection skill={'Redis'} progress={'60%'} width={'60%'} />
                <SkillsSection skill={'MySQL'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'RESTful API Development'} progress={'85%'} width={'85%'} />
                <SkillsSection skill={'Git/GitHub'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'Docker'} progress={'75%'} width={'75%'} />
                <SkillsSection skill={'Amazon Web Services (AWS)'} progress={'60%'} width={'60%'} />
                <SkillsSection skill={'React'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'Redux'} progress={'80%'} width={'80%'} />
                <SkillsSection skill={'Material UI'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'Styled Components'} progress={'95%'} width={'95%'} />
                <SkillsSection skill={'JavaScript'} progress={'85%'} width={'85%'} />
                <SkillsSection skill={'TypeScript'} progress={'75%'} width={'75%'} />
                <SkillsSection skill={'Tailwind CSS'} progress={'75%'} width={'75%'} />
                <SkillsSection skill={'SASS/SCSS'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'HTML/CSS'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'UI/UX Design'} progress={'60%'} width={'60%'} />
             </div>
        </div>
    )
}

export default Skills
